import { connect } from 'react-redux'
import selectCurrentConversationId from 'ducks/searches/selectors/selectCurrentConversationId'
import View from './view'

const select = state => {
  return {
    currentConversationId: selectCurrentConversationId(state),
  }
}

const perform = () => {
  // eslint-disable-next-line no-unused-vars
  return dispatch => ({
    doCancelOrder: payload => {
      // this is a placeholder
      const action = { type: 'cancel', payload }
      // eslint-disable-next-line no-console
      console.log(action)
      // dispatch(action)
    },
  })
}

export default connect(select, perform)(View)
